export const costs = [
  'Prepari ogni lezione di scienze forensi da zero, cercando materiale sparso su internet',
  'Spiegare prove, impronte e DNA senza immagini chiare è difficile',
  'Non hai attività, casi di studio e verifiche pronte da usare in classe',
  'Ti manca tempo per programmare unità didattiche complete e coerenti',
];
